import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';

@Component({
  selector: 'app-app-default-redirect',
  standalone: true,
  template: `
    <main class="route-bridge">
      <div class="route-bridge__label">Workspace routing</div>
      <h1>Opening your default workspace</h1>
      <p>Your role and product access determine the next screen.</p>
    </main>
  `
})
export class AppDefaultRedirectComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.router.navigateByUrl(this.authService.getDefaultAppRoute());
  }
}
